import PropTypes from "prop-types";

import { strCode } from "../../../../consts";

import { t } from "../../../../services";
import { FlexContainers, SmallButton, WrapperContainer } from "../../../../components";

const ControlButtons = ({ onCancel, onContinue, isMissingKeysModalLocalizationUploaded }) => {
  return (
    <WrapperContainer Container={FlexContainers.FlexRowEnd} mt={24} gap={14}>
      <SmallButton secondary onClick={onCancel}>
        {isMissingKeysModalLocalizationUploaded
          ? t(strCode.CLOSE_BTN)
          : t(strCode.CANCEL_UPLOAD_BTN)}
      </SmallButton>

      {!isMissingKeysModalLocalizationUploaded && (
        <SmallButton onClick={onContinue}>{t(strCode.CONTINUE_BTN)}</SmallButton>
      )}
    </WrapperContainer>
  );
};

ControlButtons.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  isMissingKeysModalLocalizationUploaded: PropTypes.bool.isRequired
};

export default ControlButtons;
